import {
    Box, Flex,
    Heading,
    Text,
    useDisclosure,
    VStack
} from "@chakra-ui/react";
import {PaginationRow, StyledButton} from "../../../components";
import {useState} from "react";
import {ReactComponent as Delete} from "../../../assets/icons/profile/notifDelete.svg";
import {ReactComponent as Read} from "../../../assets/icons/profile/read.svg";
import {ReactComponent as Unread} from "../../../assets/icons/profile/unread.svg";
import {ReactComponent as Edit} from "../../../assets/icons/profile/edit.svg";
import {MenuNotif} from "../../../helpers/data-jsons";

const MenuNotification = ({setActiveTab}) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(5);

    const totalPages = Math.ceil(MenuNotif.length / itemsPerPage);
    const currentItems = MenuNotif.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

    return (
        <VStack
            color={'neutral.100'}
            bg={'neutral.1100'}
            borderRadius={{base: '0', md: '16px'}}
            gap={'32px'}
            p={{base: '16px', md: '16px 32px'}}
            w={'100%'}>
            <Box
                w={'full'}
                display={'flex'}
                flexDirection={'column'}
                gap={'16px'}
            >
                <Flex
                    justifyContent={'space-between'}
                    alignItems={'center'}
                    p={{base: '16px 10px', md: '11px 0'}}
                    w={'100%'}
                >
                    <Heading color={'neutral.100'} fontSize={{base:'18px',md:'heading.3xl'}}>Notifications</Heading>
                    <StyledButton
                        bg={'#6F41D240'}
                        fontSizeBase={'14px'}
                        border={'solid 1px #5834A8'}
                        maxWidth={'139px'}
                        maxHeight={'32px'}
                        fontSize={'14px'}
                        fontWeight={'500'}
                    >Mark All as Read</StyledButton>
                </Flex>
                {currentItems.map((item) => (
                    <Box
                        key={item.id}
                        w={'full'}
                        display={'flex'}
                        flexWrap={'wrap'}
                        flexDirection={'column'}
                        justifyContent={'space-between'}
                        minH={'133px'}
                    >
                        <VStack
                            w={'full'}
                            borderRadius={'8px'}
                            bg={'neutral.1000'}
                            alignItems={'flex-start'}
                            p={'16px'}
                            h={'full'}
                            gap={'16px'}>
                            <Box
                                w={'full'}
                                paddingLeft={'16px'}
                                gap={'16px'}
                                display={'flex'}
                                flexDirection={'column'}
                                justifyContent={'space-between'}
                            >
                                <Box
                                    w={'full'}
                                >
                                    <Box display={'flex'}
                                         flexDirection={'row'}
                                         alignItems={'center'}
                                         justifyContent={'space-between'}>
                                        <Heading fontSize={'18px'} fontWeight={'500'}
                                                 textTransform={'capitalize'}>{item.title}</Heading>
                                        <Flex gap={'8px'}>
                                            <StyledButton
                                                maxHeight={'32px'}
                                                border={'solid 1px #5834A8'}
                                                padding={'8px 6px'}
                                                bg={'transparent'}
                                                maxWidth={'32px'}><Delete/>
                                            </StyledButton>
                                            <StyledButton
                                                maxHeight={'32px'}
                                                border={'none'}
                                                padding={'8px 6px'}
                                                hoverBg={'unset'}
                                                shadowHoverColor={'unset'}
                                                bg={'transparent'}
                                                maxWidth={'32px'}>{item.status == 0 ? <Unread/> : <Read/>}
                                            </StyledButton>
                                        </Flex>
                                    </Box>
                                    <Text color={'neutral.500'} fontSize={'14px'}>{item.date}</Text>
                                </Box>
                                <Box>
                                    <Flex
                                        flexDirection={'column'}>
                                        <Text color={'neutral.500'} fontSize={'16px'}>{item.text}</Text>
                                    </Flex>
                                </Box>
                            </Box>
                        </VStack>
                    </Box>
                ))}
            </Box>
            <PaginationRow
                width={'full'}
                pageCount={totalPages}
                onPageChange={setCurrentPage}
                itemsPerPage={itemsPerPage}
                onItemsPerPageChange={(newCount) => {
                    setItemsPerPage(newCount);
                    setCurrentPage(0);
                }}
            />
        </VStack>
    )
}
export default MenuNotification